import { MetaDataInterface } from 'models';
import { ElectricalPowerUnitEnum, EnergyUnitEnum } from 'utils/units';

export type FetchReservedCapacityGuardingActionsParams = {
  periodStart?: string;
  periodEnd?: string;
  tradingDay?: string;
  accessDeliveryPointId?: string;
  deviceIds?: string[];
  guardingCheckIds?: number[];
  statuses?: ReservedCapacityGuardingActionStatusEnum[];
};

export type ReservedCapacityGuardingAction = {
  reservedCapacityGuardingActionId: number;
  deviceId?: string;
  deviceName: string;
  endDeliveryPointId: string;
  endDeliveryPointName: string;
  relatedGuardingCheck: ReservedCapacityGuardingCheckReference;
  status: ReservedCapacityGuardingActionStatusEnum;
  actualEnergy: number;
  endOfPeriodEnergy: number;
  actionEnergy: number;
  energyUnit: EnergyUnitEnum;
  keepForNextPeriod: boolean;
  actionStart: string;
  actionType: ReservedCapacityGuardingActionTypeEnum;
  validFor: TimePeriod;
  powerActions: ReservedCapacityGuardingPowerAction[];
  meta: MetaDataInterface;
};

export type GuardingActionPreview = {
  newActionEnergy: number;
  cumulativeEnergyOfftake: number;
};

type ReservedCapacityGuardingCheckReference = {
  reservedCapacityGuardingCheckId: number;
  actualTime: string;
};

type TimePeriod = {
  validFromDate?: string;
  validToDate?: string;
};

type ReservedCapacityGuardingPowerAction = {
  setTime: string;
  powerValue: number;
  powerUnit: ElectricalPowerUnitEnum;
};

export enum ReservedCapacityGuardingActionStatusEnum {
  Issued = 'ISSUED',
  Accepted = 'ACCEPTED',
  Rejected = 'REJECTED',
  Expired = 'EXPIRED'
}

export enum ReservedCapacityGuardingActionTypeEnum {
  Reduction = 'ENERGY_REDUCTION',
  Increase = 'ENERGY_INCREASE'
}
